export default {"src":"/_next/static/media/image.21fdae00.svg","height":512,"width":513};